import React from 'react';
import { FiLogIn, FiShoppingBag } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { categories } from '../constant';
import DrawerNavigation from './drawer';

export default function Navbar({ logo }) {
    return (
        <div className="w-screen h-full z-10 shadow-none border-none ">
            <div
                className={` hidden md:block py-3 w-screen fixed z-20 top-0 px-5   bg-white shadow-md text-black`}
            >
                <div className="flex justify-between items-center">
                    <Link to={"/"}>
                        <img
                            src={logo}
                            alt=""
                            className="w-16 h-16 rounded"
                        />
                    </Link>
                    <div className="flex items-center mt-5 justify-center">
                        <div className="flex-grow   flex flex-wrap gap-4 items-center justify-center">
                            {categories.map((category) => {
                                return (
                                    <div key={category.name} className="dropdown dropdown-hover">
                                        <div
                                            tabIndex={0}
                                            role="button"
                                            className=" text-gray-500 text-sm m-1"
                                        >
                                            {category.name}
                                        </div>
                                        {category.subcategories?.length > 0 && (
                                            <ul
                                                tabIndex={0}
                                                className="dropdown-content  grid grid-cols-2 text-gray-500 z-24 menu py-3 px-4 shadow bg-base-100 rounded w-max"
                                            >
                                                {category.subcategories.map((subCategory, subIndex) => (
                                                    <li key={subIndex}>
                                                        {subCategory.name === "" ? (
                                                            <span className="opacity-0"></span>
                                                        ) : (
                                                            <a href={subCategory.link}>{subCategory.name}</a>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                );

                            })}
                        </div>
                    </div>
                    <div className="flex gap-3 w-[200px]">
                        <a href="#">
                            <div className="gap-2 flex items-center">
                                <FiLogIn />
                                Login
                            </div>
                        </a>

                        <a href="#">
                            <div className="gap-2 flex items-center">
                                <FiShoppingBag />
                                Cart
                            </div>
                        </a>
                    </div>
                </div>

            </div>
            <div className="flex items-center justify-between md:hidden bg-white">
                <DrawerNavigation />
                <Link to={"/"}>
                    <img src={logo} alt="" className=" w-14 h-14" />
                </Link>
                <div className="w-[20px] p-4 "></div>
            </div>
        </div>
    );
}
